import { useMemo } from "react";
import { useModuleBEM } from "@b2bportal/core-themes";
import { Product } from "@b2bportal/purchase-api";
import { useCheckoutFintechProducts } from "@hopper-b2b/checkout";
import { useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import { useApacHotelsStyles } from "../../hooks";
import { ApacHotelsComponent } from "../../types/componentKeys";
import defaultStyles from "./FintechPriceBreakdownSection.module.scss";

const COMPONENT_KEY = ApacHotelsComponent.FintechPriceBreakdownSection;

export const FintechPriceBreakdownSection = () => {
  const styles = useApacHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);
  const { t, formatFiatCurrency } = useI18nContext();

  const checkoutFintechItems = useCheckoutFintechProducts();

  const fintechLineItems = useMemo(
    () =>
      Object.entries(checkoutFintechItems).flatMap(([productType, data]) => {
        if (data == null) {
          return [];
        }

        if (productType === Product.LodgingCfar) {
          return [
            {
              label: t("core-hotels-cfar-offers.checkout.productName"),
              value: data.totalPremiumAmount.fiat,
            },
          ];
        }

        if (productType === Product.HtsLodgingCfar) {
          return [
            {
              label: t("core-hotels-cfar-offers.checkout.productName"),
              value: data.totalPremiumAmount.fiat,
            },
          ];
        }

        return [];
      }),
    [checkoutFintechItems, t]
  );

  if (fintechLineItems.length === 0) {
    return null;
  }

  return (
    <div
      className={clsx(block, {
        [cn("border-top")]: fintechLineItems.length > 0,
      })}
    >
      {fintechLineItems.map(({ label, value }) => (
        <div className={cn("fintech-item")}>
          <div className={cn("fintech-item-label")}>{label}</div>

          <div className={cn("fintech-item-value")}>
            {formatFiatCurrency(value)}
          </div>
        </div>
      ))}
    </div>
  );
};
